import { useMsal } from '@azure/msal-react';
import { Button, IconButton, Container, Grid, Paper, Typography, CircularProgress, Checkbox, } from '@material-ui/core'
import { CheckBox, CheckBoxOutlineBlank, KeyboardArrowRight } from "@material-ui/icons";
import React, { ReactElement, useEffect } from 'react';
import {
    getDatenabruf,
    getMessstellen,
    resetRequest,
    selectDatenabrufListe,
    selectDatenabrufListeLoading,
    selectSelectedRequest,
    selectSelectedRequestsList,
    setSelectedRequest,
} from './datenabrufSlice';
import { useStyles } from './datenabrufStyles';
import { DataGrid, deDE, GridCellParams, GridColDef, GridValueFormatterParams, LocalizationV4 } from '@material-ui/data-grid';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { globalStyles } from '../../../assets/globalStyles';
import { datenabruf, } from '../../../utils/apiTypes';
import { selectDate } from '../../../features/konfiguration/konfigurationSlice';
import { toUTCDateString } from '../../../utils/utils';
import { isAuthorized, rollen } from '../../../utils/auth/authConfig';

export default function Datenabruf(): ReactElement {

    const dispatch = useAppDispatch();

    const { instance } = useMsal();

    useEffect(() => {
        dispatch(getMessstellen())
        dispatch(getDatenabruf());
    }, [instance]);

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const datenabrufListe = useAppSelector(selectDatenabrufListe);
    const isUTC = useAppSelector(selectDate);
    const selectedRequestsList = useAppSelector(selectSelectedRequestsList)
    const datenabrufListLoading = useAppSelector(selectDatenabrufListeLoading);

    const datenabrufGridCols: GridColDef[] = [
        {
            field: "selected", headerName: "Selected", flex: 0.5, sortable: false,
            renderCell: function actions(params: GridCellParams) {
                return <Checkbox
                    icon={<CheckBoxOutlineBlank fontSize="small" />}
                    checkedIcon={<CheckBox fontSize="small" />}
                    style={{ marginRight: -10 }}
                    checked={selectedRequestsList.includes(params.row.id)}
                    onChange={() => {
                        dispatch(setSelectedRequest(params.row.id))

                    }}
                />
            },
        },
        { field: 'service', headerName: 'Service', flex: 0.7, sortable: false },
        {
            field: 'von', headerName: 'Von', flex: 0.6, sortable: false,
            valueFormatter: (params: GridValueFormatterParams) =>
                (isUTC ? toUTCDateString(new Date(params.row.from)) : new Date(params.row.from).toLocaleString())

        },
        {
            field: 'bis', headerName: 'Bis', flex: 0.6, sortable: false,
            valueFormatter: (params: GridValueFormatterParams) =>
                (isUTC ? toUTCDateString(new Date(params.row.to)) : new Date(params.row.to).toLocaleString())

        },
        { field: 'messstellen', headerName: 'Messstellen', flex: 0.7, sortable: false },
        {
            field: 'kenngrößen', headerName: 'Kenngrößen', flex: 0.6, sortable: false,


        },
        {
            field: 'erstellungszeitpunkt', headerName: 'Erstellungszeitpunkt', flex: 0.8, sortable: false,
            valueFormatter: (params: GridValueFormatterParams) => (isUTC ? toUTCDateString(new Date(params.row.creationTime)) : new Date(params.row.creationTime).toLocaleString())
        },

        {
            field: 'resetService', headerName: 'Reset service', flex: 0.8, sortable: false,
            renderCell: function actions(params: GridCellParams) {
                return <IconButton color="secondary" style={{ fontSize: "medium" }} onClick={() => {
                    dispatch(resetRequest(params.row.id));
                }
                }>Reset<KeyboardArrowRight /></IconButton>
            },
        },

    ]

    function printTable(data: datenabruf[]) {
        return (
            <Container maxWidth={false} className={classes.root}>
                <div style={{ height: "45vh" }}>
                    {datenabrufListLoading ? <CircularProgress /> : <DataGrid
                        localeText={(deDE as LocalizationV4).props.MuiDataGrid.localeText}
                        columns={datenabrufGridCols}
                        rows={datenabrufListe}
                        disableColumnSelector={true}
                        loading={datenabrufListLoading}
                        className={classes.zeroPadding} />}
                </div>
            </Container>
        )
    }

    return (
        <div>
            <Container maxWidth={false} style={{ marginTop: "10px" }}>
                <Grid container md={12} spacing={2} style={{ marginBottom: "10px" }}>
                    <Grid item md={3} />
                    <Grid item md={6}>
                        <Typography color="primary" variant="h5">
                            Datenabruf
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
            <Paper className={classes.paper} style={{ marginLeft: "24px", marginRight: "24px" }}>
                <Grid container spacing={2} style={{ marginBottom: "20px", padding: "0px", paddingRight: "16px" }}>
                    <Grid item md={3} >
                        <Typography color="primary" variant="h6" className={classes.typoH6Style} style={{ marginLeft: "20px" }} >
                            Datenabruf
                        </Typography>
                    </Grid>
                    <Grid item md={3} />
                    <Grid item md={2} />
                    <Grid item md={4} style={{ paddingRight: "24px", paddingTop: "0px" }}>
                        {isAuthorized([rollen.everyone]) ?
                            <Grid item md={12} style={{ display: "flex" }}>
                                <Grid item md={6}>
                                    <Button
                                        variant="contained"
                                        onClick={() => datenabrufListe.map(x => dispatch(resetRequest(x.id)))}
                                        color="secondary"
                                        className={classes.showButton}
                                    >
                                        Reset all requests
                                    </Button></Grid>
                                <Grid item md={6}><Button
                                    variant="contained"
                                    onClick={() => selectedRequestsList.map(x => dispatch(resetRequest(Number(x))))}

                                    color="secondary"
                                    className={classes.showButton}
                                >
                                    Reset selected requests
                                </Button></Grid>
                            </Grid> : ""}
                    </Grid>

                    {printTable(datenabrufListe)}

                </Grid>
            </Paper>
        </div>
    )
}

